function productTabs(evt, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabName).style.display = "flex";
    evt.currentTarget.className += " active";
}

// TMFS DRAFT 22 Oct 2026 (Lumi): replaces the 17 Sep "basket repair" full-page reload.
// When a shopper returns with Back/Forward (including a page restored from the back-forward cache),
// re-read the basket from /cart.js and refresh only the basket count and basket drawer contents.
// No page reload, and no 'cart:update' event (that event would auto-open the basket drawer).
(function () {
    function syncCartAfterBack() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) {
                if (!cart) return;
                var count = cart.item_count || 0;
                document.querySelectorAll('cart-icon').forEach(function (icon) {
                    if (typeof icon.renderCartBubble === 'function' && icon.currentCartCount !== count) {
                        icon.renderCartBubble(count, false, false);
                    }
                });
                var lists = document.querySelectorAll('cart-items-component[data-section-id]');
                if (!lists.length) return;
                import('@theme/section-renderer').then(function (mod) {
                    lists.forEach(function (list) {
                        mod.sectionRenderer.renderSection(list.dataset.sectionId, { cache: false });
                    });
                }).catch(function () {});
            })
            .catch(function () {});
    }

    window.addEventListener('pageshow', function (event) {
        var navigation = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
        if (event.persisted || (navigation && navigation.type === 'back_forward')) {
            syncCartAfterBack();
        }
    });
})();
